import React from 'react'

import Client1 from '../../assets/images/sattva_frameworks/1.png';
import Client2 from '../../assets/images/sattva_frameworks/2.png';
import Client3 from '../../assets/images/sattva_frameworks/3.png';
import Client4 from '../../assets/images/sattva_frameworks/4.png';
import Client5 from '../../assets/images/sattva_frameworks/5.png';
import Client6 from '../../assets/images/sattva_frameworks/6.png';
import Client7 from '../../assets/images/sattva_frameworks/7.png';
import Client8 from '../../assets/images/sattva_frameworks/8.png';

export default function ESGFrameWork() {

    const logos = [Client1, Client2, Client4, Client3, Client5, Client6, Client7, Client8];
    return (
        <section className="relative py-16 active" id="esg-frameworks">
            <div className="container">
                <div className="grid grid-cols-1 pb-8 text-center">
                    {/* <h6 className="text-blue-600 text-base font-medium uppercase mb-2">ESG Framework</h6> */}
                    <h3 className="mb-4 md:text-2xl text-xl font-medium dark:text-white">Corporate Reporting Customized for All Businesses</h3>
                    {/* <p className="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">Launch your campaign and benefit from our expertise on designing and managing conversion centered Tailwind CSS html page.</p> */}
                </div>
                <div className="overflow-hidden w-full py-6">
                    {/* Wrapper with relative width */}
                    <div
                        className="flex space-x-8"
                        style={{
                            animation: "scroll 20s linear infinite",
                        }}
                    >
                        {logos.concat(logos).map((logo, index) => (
                            <div
                                key={index}
                                className="flex-shrink-0 w-36 h-36 bg-white rounded-2xl shadow-md border border-gray-100 flex items-center justify-center p-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                                <img
                                    src={logo}
                                    alt={`logo-${index}`}
                                    className="h-full w-full object-contain transition duration-300"
                                />
                            </div>
                        ))}
                    </div>

                    {/* Inline CSS for animation */}
                    <style jsx>{`@keyframes scroll {0% {transform: translateX(0);}100% {transform: translateX(-50%);}}`}</style>
                </div>
            </div>
        </section>
    )
}
